export default __webpack_public_path__ + "static/media/aimate-screenshot-05.3614efc4.png";